<script setup>
defineProps({
    question: {
        type: Object,
        required: true,
    },
});
const value = defineModel({ type: Array, default: () => [] });
</script>

<template>
    <div class="flex flex-col gap-2">
        <label class="flex gap-1 items-center" v-for="choice in question.options.choices" :key="choice.id">
            <input
                v-model="value"
                :name="`question_${question.id}`"
                :value="choice.value"
                type="checkbox"
                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
            />
            <span>{{ choice.text }}</span>
        </label>
    </div>
</template>
